export default "__VITE_ASSET__BcWLZBWP__"